import { sendFriendRequest } from 'legacy/user/service';

import { useMutation } from 'react-query';
import { ErrorResponse } from 'legacy/common/utils/error';
import { GenericSuccessResponse } from 'legacy/common/types/response';

export function useSendFriendRequest({ userId }: { userId: string }) {
  return useMutation<GenericSuccessResponse, ErrorResponse>(() =>
    sendFriendRequest(userId)
  );
}
